import { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useAuth } from './hooks/useAuth'
import { useAuthStore } from './store/authStore'
import { Login } from './pages/Login'
import { Projects } from './pages/Projects'
import { ProjectDetail } from './pages/ProjectDetail'
import { WebSocketProvider } from './context/WebSocketContext'
import { ReferencesPage } from './pages/ReferencesPage'
import { OAuthCallback } from './pages/OAuthCallback'
import { PricingPage } from './pages/PricingPage'
import { AdminPage } from './pages/AdminPage'
import { DocumentSearchPage } from './pages/DocumentSearchPage'
import { Loading } from './components/Common/Loading'

export const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return children
}

// Маршрут только для администраторов (is_admin)
export const AdminRoute = ({ isAuthenticated, user, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  if (!user?.is_admin) {
    return <Navigate to="/projects" replace />
  }

  return children
}

export default function App() {
  const { token, user } = useAuthStore()

  return (
    <Router>
      <WebSocketProvider>
          <Toaster
                position="top-right"
                reverseOrder={false}
                gutter={8}
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                }}
              />
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback/google" element={<OAuthCallback />} />
            <Route path="/auth/callback/github" element={<OAuthCallback />} />
            <Route path="/auth/callback/yandex" element={<OAuthCallback />} />

            <Route
              path="/projects"
              element={
                <ProtectedRoute isAuthenticated={!!token}>
                  <Projects />
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:cardId"
              element={
                <ProtectedRoute isAuthenticated={!!token}>
                  <ProjectDetail/>
                </ProtectedRoute>
              }
            />
            <Route
              path="/search"
              element={
                <ProtectedRoute isAuthenticated={!!token}>
                  <DocumentSearchPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pricing"
              element={
                <ProtectedRoute isAuthenticated={!!token}>
                  <PricingPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <AdminRoute isAuthenticated={!!token} user={user}>
                  <AdminPage />
                </AdminRoute>
              }
            />
            {/* Справочники - только для администраторов */}
            <Route
              path="/settings"
              element={
                <AdminRoute isAuthenticated={!!token} user={user}>
                  <ReferencesPage />
                </AdminRoute>
              }
            />
            <Route path="/" element={<Navigate to="/projects" replace />} />
          </Routes>
      </WebSocketProvider>
    </Router>
  )
}
